// Taric - Dazzle: fires a stunning gem beam at the front 2 enemies.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const taricDazzle: Ability = {
  id: "taricDazzle",
  displayName: "Dazzle",
  description: "Stuns the front 2 enemies for 1 turn and deals 0.8× AP + 60 magic damage to each.",
  iconId: "TaricDazzle",

  targetShape({ caster, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(enemyTeam).sort((a, b) => a.pos.q - b.pos.q).slice(0, 2);
    return targets.map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(enemyTeam).sort((a, b) => a.pos.q - b.pos.q).slice(0, 2);
    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 0.8 + 60);

    return targets.map(e => ({
      target: e,
      amount: dmg,
      type: "magical" as const,
      effect: { kind: "stun" as const, duration: 1 },
    }));
  },
};
